import React from "react";
import { useChat } from "../../../context/ChatContext";
import { useContacts } from "../../../hooks/useContacts";
import { extractShortName, formatCellphone } from "../../../utils";

interface ContactSharedProps {
  contactId: string;
}

// ---------- PARSE ----------
export function parseContactShared(body: string) {
  if (!body) {
    return { title: "", name: "", phone: "" };
  }

  let clean = body.replace("Contato compartilhado:", "").trim();
  const parts = clean.split(" - ");

  return {
    title: "Contato compartilhado",
    name: parts[0]?.trim() ?? "",
    phone: parts[1]?.trim() ?? "",
  };
}

// ---------- INITIALS ----------
const getInitials = (name: string) => {
  if (!name) return "?";
  const parts = name.trim().split(" ");
  if (parts.length === 1) return parts[0][0].toUpperCase();
  return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
};


const ContactSharedMessage = ({
  contactId
}: ContactSharedProps) => {

  const { handleSelectChat } = useChat();
  const { contacts } = useContacts();
  const contactIdNumber = Number(contactId);

  const contact = contacts.find(c => c.id === contactIdNumber);
  if (!contact) return;
  const initials = extractShortName(contact.name, "");


  return (
    <div className="location-message p-2 border rounded bg-light d-flex justify-content-between align-items-center">

      {/* Avatar */}
      <div style={styles.avatar}>
        <span>{initials.shortName}</span>
      </div>

      {/* Conteúdo */}
      <div className="flex-grow-1 ms-3">
        <div style={styles.title}>Contato compartilhado</div>
        {/* <h5 className="font-size-14 m-0">{contact.name}</h5> */}
        <div style={styles.name}>{contact.name}</div>
        <div style={styles.phone}>{formatCellphone(contact.phoneNumber)}</div>
      </div>

      {/* Botão à direita */}
      <button
        type="button"
        className="ms-3 btn btn-sm btn-outline-primary"
        onClick={() => handleSelectChat(contact.id)}
      >
        Abrir chat
      </button>

    </div>

  );
};

export default ContactSharedMessage;

// ---------- STYLES ----------
const styles: Record<string, React.CSSProperties> = {
  container: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    background: "#f8f9fa",
    padding: "12px",
    borderRadius: "10px",
    border: "1px solid #e5e7eb",
    gap: "12px",
    maxWidth: "320px",
  },

  avatar: {
    width: "44px",
    height: "44px",
    background: "#d1d5db",
    color: "#111",
    borderRadius: "50%",
    fontSize: "17px",
    fontWeight: 600,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexShrink: 0,
  },

  content: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    lineHeight: "18px",
  },

  title: {
    fontSize: "15px",
    fontWeight: 700,
    color: "#6b7280",
    marginBottom: "2px",
  },

  name: {
    fontSize: "15px",
    fontWeight: 700,
    color: "#374151",
  },

  phone: {
    fontSize: "13px",
    color: "#374151",
    marginBottom: "6px",
  },

  button: {
    marginTop: "6px",
    padding: "4px 10px",
    fontSize: "12px",
    fontWeight: 600,
    background: "#4f46e5",
    color: "#fff",
    borderRadius: "6px",
    border: "none",
    cursor: "pointer",
    alignSelf: "flex-start",
  },
};
